import styled, { css } from "styled-components";

const Button = styled.button`
  padding: 12px;
  border: none;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;

  ${props =>
    props.primary &&
    css`
      background: #488aff;
    `};

  ${props =>
    props.cancel &&
    css`
      background: #d94a38;
      margin-right: 10px;
    `};

  &:hover {
    cursor: pointer;
  }
`;

export default Button;
